module.exports = __webpack_public_path__ + "img/HORNOS.b83070fa.jpg";